import HttpService from "./htttp.service";

class EventService {
  getEvents = async (month, year) => {
    let query = "events";

    // if (month && year) {
    //   query += `?month=${month}&year=${year}`;
    // }

    return await HttpService.get(query);
  };

  createEvent = async (payload) => {
    return await HttpService.post("events", payload);
  };

  updateEvent = async (id, payload) => {
    return await HttpService.patch(`events/${id}`, payload);
  };

  cancelEvent = async (id) => {
    return await HttpService.post(`events/${id}/cancel`);
  };

    restoreEvent = async (id) => {
    return await HttpService.post(`events/${id}/restore`);
  };
}

export default new EventService();
